require('/opt/odin/app/frontend/components/lesson_player/faq/index.module.scss');module.exports = "../../app/cells/components/lesson_player/faq/show.erb";